import React from 'react';
import './ClearLeaveConfirmModal.css';

function ClearLeaveConfirmModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  leaveRequest,
  formatDate,
  formatDays
}) {
  if (!isOpen || !leaveRequest) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="clear-leave-modal-overlay" onClick={handleCancel}>
      <div className="clear-leave-modal" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="clear-leave-modal-header">
          <div className="clear-leave-header-content">
            <h3 className="clear-leave-modal-title">
              Clear Cancelled Leave Request
            </h3>
          </div>
          <button className="clear-leave-close-btn" onClick={handleCancel}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div className="clear-leave-modal-body">
          {/* Warning Banner for Permanent Deletion */}
          <div className="clear-leave-warning-banner">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            <div className="clear-leave-warning-text">
              <strong>Permanent Deletion Warning</strong>
              <p>This action will permanently delete the cancelled leave request from your history. This cannot be undone.</p>
            </div>
          </div>

          <div className="clear-leave-confirm-message">
            <p className="clear-leave-question">
              Are you sure you want to permanently delete this cancelled leave request?
            </p>
          </div>

          {/* Leave Details Card */}
          <div className="clear-leave-details-card">
            <h4 className="clear-leave-details-title">Leave Request Details</h4>
            
            <div className="clear-leave-detail-row">
              <div className="clear-leave-detail-label">Leave Type</div>
              <div className="clear-leave-detail-value">
                <span 
                  className="clear-leave-type-dot" 
                  style={{backgroundColor: leaveRequest.leave_type_details?.color || '#4CAF50'}}
                ></span>
                {leaveRequest.leave_type_details?.name || 'Unknown'}
              </div>
            </div>

            <div className="clear-leave-detail-row">
              <div className="clear-leave-detail-label">Start Date</div>
              <div className="clear-leave-detail-value">
                {formatDate(leaveRequest.start_date)}
              </div>
            </div>

            <div className="clear-leave-detail-row">
              <div className="clear-leave-detail-label">End Date</div>
              <div className="clear-leave-detail-value">
                {formatDate(leaveRequest.end_date)}
              </div>
            </div>

            <div className="clear-leave-detail-row">
              <div className="clear-leave-detail-label">Total Days</div>
              <div className="clear-leave-detail-value clear-leave-days-highlight">
                {formatDays(leaveRequest.total_days)} days
              </div>
            </div>

            <div className="clear-leave-detail-row">
              <div className="clear-leave-detail-label">Status</div>
              <div className="clear-leave-detail-value">
                <span className="clear-leave-status-badge cancelled">
                  Cancelled
                </span>
              </div>
            </div>

            {leaveRequest.reason && (
              <div className="clear-leave-detail-row clear-leave-reason-row">
                <div className="clear-leave-detail-label">Reason</div>
                <div className="clear-leave-detail-value clear-leave-reason-text">
                  {leaveRequest.reason}
                </div>
              </div>
            )}
          </div>

          {/* Impact Notice */}
          <div className="clear-leave-impact-notice">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            <div className="clear-leave-impact-text">
              <strong>What happens next:</strong>
              <ul>
                <li>The cancelled leave request will be permanently deleted from your history</li>
                <li>This action cannot be undone</li>
                <li>An audit log entry will be created for record-keeping purposes</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="clear-leave-modal-footer">
          <button className="clear-leave-btn-secondary" onClick={handleCancel}>
            Keep Request
          </button>
          <button className="clear-leave-btn-danger" onClick={handleConfirm}>
            Yes, Delete Request
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClearLeaveConfirmModal;




